import { Trophy, Flag, Users, Activity, Database, Shield, Archive as ArchiveIcon, AlertTriangle } from "lucide-react";
import { StatCard } from "@/components/SiteAdminParts";
import DeploymentReadinessBanner from "@/components/site-admin/DeploymentReadinessBanner";

// Extracted from /pages/SiteAdmin.jsx in iter84.40 (tech debt sweep #4
// batch 2). Renders the seven stat cards plus the platform-only
// readiness banner. Parent gates rendering on `stats` being non-null.
// iter84.60.9 — The nine healer/tool cards (ESPN sync repair, KO labels,
// ratchet/tied-KO audits, team-stat recompute, upstream winner re-pull,
// poller cadence, data drift, bulk cleanup) MOVED to the Platform
// Console → Game Ops → APIs & Healers sub-tab. Operator tooling now
// lives with the platform identity, not the tenant overview.
export default function OverviewTab({ admin, scopeView, stats }) {
    return (
        <>
            {admin?.role === "platform_admin" && scopeView === "platform" && (
                <DeploymentReadinessBanner />
            )}
            <div className="grid sm:grid-cols-2 lg:grid-cols-4 gap-3" data-testid="site-stats-grid">
                <StatCard label="Open requests" value={stats.open_requests ?? 0} icon={Activity} color="text-heat" testId="stat-open-requests" />
                <StatCard label="Rivalries" value={stats.leagues} icon={Trophy} color="text-cyber" />
                <StatCard label="Free tier" value={stats.leagues_by_tier?.free ?? 0} icon={Trophy} color="text-zinc-300" testId="stat-tier-free" />
                <StatCard label="Pro+ tier" value={stats.leagues_by_tier?.paid ?? 0} icon={Trophy} color="text-volt" testId="stat-tier-paid" />
                <StatCard label="Comp / trial" value={stats.leagues_by_tier?.comp ?? 0} icon={Trophy} color="text-neon" testId="stat-tier-comp" />
                <StatCard label="Tournaments" value={stats.tournaments} icon={Flag} color="text-volt" />
                <StatCard label="Participants" value={stats.participants} icon={Users} color="text-neon" />
                <StatCard label="Matches" value={stats.matches} icon={Activity} color="text-blaze" />
                <StatCard label="Active drafts" value={stats.active_drafts} icon={Database} color="text-cyber" />
                <StatCard label="Completed drafts" value={stats.completed_drafts} icon={Database} color="text-neon" />
                <StatCard label="Site admins" value={stats.site_admins} icon={Shield} color="text-volt" />
                {(stats.archived_leagues ?? 0) > 0 && (
                    <StatCard label="Archived rivalries" value={stats.archived_leagues} icon={ArchiveIcon} color="text-zinc-400" testId="stat-archived-leagues" />
                )}
                {(stats.archived_past_retention ?? 0) > 0 && (
                    <StatCard label="Retention due — delete" value={stats.archived_past_retention} icon={AlertTriangle} color="text-heat" testId="stat-retention-due" />
                )}
            </div>
            {(stats.archived_past_retention ?? 0) > 0 && (
                <p className="text-[11px] text-heat" data-testid="retention-due-note">
                    ⚠ {stats.archived_past_retention} archived rivalr{stats.archived_past_retention === 1 ? "y is" : "ies are"} past the 12-month retention window
                    (tcl.policy.data-retention) — review them under Rivalry Ops → Rivalries → Archived and delete.
                </p>
            )}
            {admin?.role === "platform_admin" && (
                <p className="text-[10px] text-zinc-600" data-testid="overview-healers-moved-note">
                    Looking for the sync / healer tools? They moved to the Commons Console → Game Ops → APIs & Healers.
                </p>
            )}
        </>
    );
}
